import { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { postWebServiceWithEmail } from 'CustomHooks/postWebService';
import ValidationServices from 'Services/ValidationServices';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';

const SubscriptionForm = () => {

  const [email, setEmail] = useState("")
  const [emailValidation, setEmailValidation] = useState();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (email !== "") {
      setEmailValidation(ValidationServices.validateEmail(email));
    } else {
      setEmailValidation(true);
    }
  }, [email]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    postWebServiceWithEmail(email).then((value) => {
      if (value) {
        setOpen(false);
        setEmail("");
      }
    })
  };

  const handleOnClose = () => {
      setOpen(false);
      setEmail('')
  };

  return (
    <div>
      <Button className="button" onClick={handleClickOpen}>
        Try it out
      </Button>
      <Dialog PaperProps={{style: { borderRadius: 25 }}} className="formPopup" fullWidth maxWidth="md" onClose={handleOnClose} open={open} aria-labelledby="form-dialog-title">
        <DialogContent className="formPopup">
          <div className="fieldBox1">
            <div className="subcriptionBoxText">
              <div className="headlineSubscription">Hi there,</div>
              <div>Wiselog is currently in testing phase if you would like to give it a try reach out to us and we will contact you and guide you through the testing phase.</div>
            </div>
            <TextField
              id="email"
              label="Email"
              variant="outlined"
              className="subscriptionTextField subscriptionTextField2"
              style={{width: "70%", margin: "5px"}}
              margin="normal"
              onChange={(e) => setEmail(e.target.value)}
              error={!emailValidation}
              helperText={!emailValidation ? "Invalid email" : ""}
            />
            <Button style={{margin: "5px"}} disabled={email === "" || !emailValidation} className="dialogActionButton" onClick={handleClose}>Reach Out</Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default SubscriptionForm;
